import { create } from 'zustand'

interface CategoriesBarState {
  /**
   * True once the homepage's Categories section has been scrolled up and out of
   * the viewport. Used to reveal the header's categories nav row on the desktop
   * homepage only after the in-page Categories component leaves the viewport.
   */
  isHomeCategoriesPassed: boolean
  setHomeCategoriesPassed: (passed: boolean) => void
}

export const useCategoriesBarStore = create<CategoriesBarState>((set) => ({
  isHomeCategoriesPassed: false,
  setHomeCategoriesPassed: (passed) =>
    set((state) =>
      state.isHomeCategoriesPassed === passed ? state : { isHomeCategoriesPassed: passed },
    ),
}))
